module.exports = __webpack_public_path__ + "static/media/TD.a786636a.png";